import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Get from "../../Get";
import CamposEmbarque, { PuertoSelect } from "./CamposEmbarque";
import { usePuertos, clientePorPrefijo, revisaNumeroContenedor, guardaConAvisos, avisosEnVivo } from "./contenedorUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ContenedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_BROKERS = process.env.REACT_APP_URL_BROKERS;
  const URL_FORWARDERS = process.env.REACT_APP_URL_FORWARDERS;
  const URL_NAVIERAS = process.env.REACT_APP_URL_NAVIERAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_ARTICULOS_CONTENEDOR = process.env.REACT_APP_URL_ARTICULOS_CONTENEDOR;
  const URL_SEND_MAIL = process.env.REACT_APP_URL_SEND_MAIL;
  const [t, i18n] = useTranslation("global");

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [brokers, setBrokers] = useState([]);
  const [forwarders, setForwarders] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState("");
  const [selectedForwarder, setSelectedForwarder] = useState("");
  const [navieras, setNavieras] = useState([]);
  const [selectedNaviera, setSelectedNaviera] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [numeroReferencia, setNumeroReferencia] = useState("");
  const [referenciaExtra, setReferenciaExtra] = useState("NA");
  const [customerFor, setCustomerFor] = useState("NA");
  const [bl, setBL] = useState("No");
  const [blNumero, setBLNumero] = useState("NA");
  const [POD, setPOD] = useState("NA");
  const [flete, setFlete] = useState(0);
  const [incrementable, setIncrementable] = useState(0);
  const [puerto, setPuerto] = useState("");
  const [puertoDestino, setPuertoDestino] = useState("");
  const [referencia, setReferencia] = useState("");
  const [fechaETD, setFechaETD] = useState("");
  const [fechaETA, setFechaETA] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [totalCantidad, setTotalCantidad] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 1,
      descripcion: "NA",
      proveedor: "NA",
      marca: "NA",
      PO: 0,
      CBMS: 0,
      precio: 1,
      total: 1,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);
  const puertos = usePuertos();
  // Datos nuevos del embarque (tipo, booking, proveedor, referencia del cliente, modalidad, quién paga)
  const [embarque, setEmbarque] = useState({ tipoContenedor: "", booking: "", proveedor: "", referenciaCliente: "", modalidad: "", quienPaga: "" });
  const setEmb = (campo, valor) => setEmbarque((e) => ({ ...e, [campo]: valor }));
  const [avisoNumero, setAvisoNumero] = useState("");
  const [avisosDup, setAvisosDup] = useState([]);
  const [clienteAuto, setClienteAuto] = useState("");

  // Prefijo de la referencia (ZZH, SEL, AB…) → cliente
  const cambiaReferencia = (valor) => {
    setNumeroReferencia(valor);
    const c = clientePorPrefijo(clientes, valor);
    if (c) {
      setSelectedCliente(c._id);
      setClienteAuto(c.nombre_comercial);
    } else {
      setClienteAuto("");
    }
  };
  const revisaDuplicados = () => {
    if (!referencia && !numeroReferencia) return setAvisosDup([]);
    avisosEnVivo({ referencia, numeroReferencia }).then(setAvisosDup);
  };

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(`${URL_CLIENTES}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allClientes = res.data;
          setClientes(allClientes);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
        .get(`${URL_BROKERS}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allBrokers = res.data;
            setBrokers(allBrokers);
          })
          .catch((err) => {
            console.log(err);
          });

        axios
        .get(`${URL_FORWARDERS}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allForwarders = res.data;
            setForwarders(allForwarders);
          })
          .catch((err) => {
            console.log(err);
          });

          axios
          .get(`${URL_NAVIERAS}`, { 
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((res) => {
              const allNavieras = res.data;
              setNavieras(allNavieras);
            })
            .catch((err) => {
              console.log(err);
            });
  }, []);

const saveOrdenCompra = async (event) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();
  let totalArticulos = inputFields.length;

  try {
    await guardaConAvisos((confirmado) => axios
      .post(
        URL_CONTENEDORES,
        {
          confirmado,
          ...embarque,
          fecha,
          surtido: "No",
          status: "Abierto",
          clientes: selectedCliente,
          brokers: selectedBroker,
          forwarders: selectedForwarder,
          numeroReferencia,
          referenciaExtra,
          navieras: selectedNaviera,
          flete,
          incrementable,
          puerto,
          puertoDestino,
          referencia,
          etd: fechaETD,
          etaEstimada: fechaETA,
          etaReal: fechaETA,
          bl: "No",
          blNumero,
          customerFor,
          POD,
          pl: "No",
          totalGastos: 0,
          fechaLlegada: "2000-01-01",
          fechaLiberacion: "2000-01-01",
          fechaEntregaEstimada: "2000-01-01",
          fechaEntregaReal: "",
          aduana: "No",
          totalGeneral,
          totalCantidad,
          totalSurtido: 0,
          pendienteSurtir: totalCantidad,
          observaciones,
          montoServicio: 0,
          saldo: 0,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      ))
      .then((data) => {
        inputFields.map((a) => {
          axios
            .post(
              URL_ARTICULOS_CONTENEDOR,
              {
                fecha,
                contenedores: data.data._id,
                navieras: selectedNaviera,
                clientes: selectedCliente,
                brokers: selectedBroker,
                articulos: a.articulos,
                cantidad: parseFloat(a.cantidad),
                pendienteSurtir: parseFloat(a.cantidad),
                descripcion: a.descripcion,
                proveedor: a.proveedor,
                marca: a.marca,
                PO: a.PO,
                CBMS: a.CBMS,
                cantidadSurtido: 0,
                precio: parseFloat(a.precio),
                total: parseFloat(a.total),
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos === 0) {
                enviaMail(data.data.referencia);
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Contenedor",
                      detalle: `${selectedCliente} - ${totalGeneral}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con éxito", "success");
                    setTimeout(() => {}, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
              console.log(error);
              setValidaBoton(true);
            });
        });
      })
      .catch((error) => {
        setValidaBoton(true);
        if (error.cancelado) {
          setModalProgreso(false);
          return;
        }
        const msg = error?.response?.data?.message || "Something went wrong!";
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: msg,
        });
        console.log(error);
        setValidaBoton(true);
      });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
    });
    console.log(error);
  }
};


  function enviaMail(refecrencia){

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL,
        {
          subject: `Contenedor-${refecrencia}`,
          email: process.env.REACT_APP_MAIL_ADMIN,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
          <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
       <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
       <tbody>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
       <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Se ha creado un nuevo contenedor con el numero ${referencia}.</tr>
       </tbody>
       <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
       <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
       </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
}
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 1,
        descripcion: "NA",
        proveedor: "NA",
        marca: "NA",
        PO: 0,
        CBMS: 0,
        precio: 1,
        total: 1,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

 

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }



  return (
    <>
      <Header />
      {user.contenedoresCreate ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-ship" /></span>
                {t("Nuevo")} {t("Contenedor")}
              </h3>
              <p className="page-subtitle">{t("Alta de contenedor y sus artículos")}</p>
            </div>
          </div>
          <Form onSubmit={saveOrdenCompra}>
            {/* <Get /> */}
            <div className="form-section">
              <div className="form-section-header"><i className="fas fa-info-circle" /><h4 className="form-section-title">{t("Datos generales")}</h4></div>
              <div className="form-section-body">
                <Row>
              <Col md={2}>
                <Label>{t("Fecha")}</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">{t("Cliente")}</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedCliente}
                  required
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setClienteAuto("");
                  }}
                >
                  <option value="0">{t("Selecciona")}</option>
                  {clientes
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                    })}
                </Input>
                {clienteAuto ? <small className="campo-aviso ok"><i className="fas fa-magic" /> {t("Por prefijo")}: {clienteAuto}</small> : null}
              </Col>
              <Col md={2}>
                <Label>{t("Numero de Referencia")}</Label>
                <Input
                  type="text"
                  placeholder="NumeroReferencia"
                  value={numeroReferencia}
                  required
                  onChange={(e) => {
                    cambiaReferencia(e.target.value);
                  }}
                  onBlur={revisaDuplicados}
                />
              </Col>
              <Col md={2}>
  <Label>{t("Contenedor")}</Label>
  <Input
    type="text"
    placeholder="Referencia"
    value={referencia}
    required
    onChange={(e) => {
      const valueWithoutSpaces = e.target.value.replace(/\s/g, ''); // Elimina todos los espacios
      setReferencia(valueWithoutSpaces);
      setAvisoNumero("");
    }}
    onBlur={() => {
      setAvisoNumero(revisaNumeroContenedor(referencia));
      revisaDuplicados();
    }}
  />
  {avisoNumero ? <small className="campo-aviso"><i className="fas fa-exclamation-triangle" /> {avisoNumero}</small> : null}
</Col>
               <Col md={2}>
                <Label>{t("Customer For")}</Label>
                <Input
                  type="text"
                  placeholder="CustomerFor"
                  value={customerFor}
                  required
                  onChange={(e) => {
                    setCustomerFor(e.target.value);
                  }}
                />
              </Col>
                </Row>
                {avisosDup.length ? (
                  <div className="campo-aviso-box">
                    {avisosDup.map((a, i) => <div key={i}><i className="fas fa-clone" /> {a.mensaje}</div>)}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-section">
              <div className="form-section-header"><i className="fas fa-ship" /><h4 className="form-section-title">{t("Naviera, puertos y fechas")}</h4></div>
              <div className="form-section-body">
                <Row>
             <Col md={2}>
                <Label className="mr-sm-2">{t("Naviera")}</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedNaviera}
                  required
                  onChange={(e) => {
                    setSelectedNaviera(e.target.value);
                  }}
                >
                  <option value="0">{t("Selecciona")}</option>
                  {navieras
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.name}</option>
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>{t("Puerto de origen")}</Label>
                <PuertoSelect tipo="Origen" puertos={puertos} value={puerto} onChange={setPuerto} required />
              </Col>
             <Col md={2}>
                <Label>{t("Puerto Destino")}</Label>
                <PuertoSelect tipo="Destino" puertos={puertos} value={puertoDestino} onChange={setPuertoDestino} required />
              </Col>
              <Col md={2}>
                <Label>{t("POD")}</Label>
                <Input
                  type="text"
                  placeholder="POD"
                  value={POD}
                  required
                  onChange={(e) => {
                    setPOD(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>ETD</Label>
                <Input
                  type="date"
                  placeholder="Fecha ETD"
                  value={fechaETD}
                  required
                  onChange={(e) => {
                    setFechaETD(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>ETA</Label>
                <Input
                  type="date"
                  placeholder="Fecha ETA"
                  value={fechaETA}
                  required
                  onChange={(e) => {
                    setFechaETA(e.target.value);
                  }}
                />
              </Col>
                </Row>
              </div>
            </div>
            <div className="form-section">
              <div className="form-section-header"><i className="fas fa-user-tie" /><h4 className="form-section-title">{t("Broker, forwarder y flete")}</h4></div>
              <div className="form-section-body">
                <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Broker</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedBroker}
                  required
                  onChange={(e) => {
                    setSelectedBroker(e.target.value);
                  }}
                >
                  <option value="0">{t("Selecciona")}</option>
                  {brokers
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Forwarder</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedForwarder}
                  required
                  onChange={(e) => {
                    setSelectedForwarder(e.target.value);
                  }}
                >
                  <option value="0">{t("Selecciona")}</option>
                  {forwarders
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if(user.tipo == "Forwarder"){
                        if(a._id == user.forwarders){
                          return <option value={a._id}>{a.name}</option>;
                        }
                      }else{
                        return <option value={a._id}>{a.name}</option>
                      }
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>{t("BL")}</Label>
                <Input
                  type="text"
                  placeholder="BlNumero"
                  value={blNumero}
                  required
                  onChange={(e) => {
                    setBLNumero(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>{t("Flete")}</Label>
                <Input
                  type="number"
                  placeholder="Flete"
                  value={flete}
                  required
                  onChange={(e) => {
                    setFlete(e.target.value);
                  }}
                />
              </Col>
            <Col md={2}>
                <Label>{t("Incrementable")}</Label>
                <Input
                  type="select"
                  placeholder="Incrementable"
                  value={incrementable}
                  required
                  onChange={(e) => {
                    setIncrementable(e.target.value);
                  }}
                >
                 <option value="">{t("Selecciona")}</option>
                 <option value="Si">{t("Si")}</option>
                 <option value="No">{t("No")}</option>
                  
                </Input> 
              </Col>
                </Row>
                <Row>
                  <CamposEmbarque valores={embarque} set={setEmb} quienPagaObligatorio />
                </Row>
              </div>
            </div>
            <div className="form-section">
              <div className="form-section-header"><i className="fas fa-boxes" /><h4 className="form-section-title">{t("Articulos")}</h4></div>
              <div className="form-section-body">
            <Row>
             
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTAL {totalCantidad} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(totalGeneral)}
                </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">{t("Articulos")}</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">{t("Descripcion")}</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">{t("Proveedor")}</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">{t("Marca")}</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">{t("PO")}</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">{t("CBMS")}</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">{t("Cantidad")}</Label>
              </Col>
              {/* <Col md={1}>
                <Label className="mr-sm-2">{t("Precio")} USD</Label>
              </Col> */}
              {/* <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col> */}
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.articulos}
                      required
                      onChange={(event) => {
                        handleChangeInput(inputField.id, event);
                      }}
                    >
                      <option value="0">{t("Selecciona")}</option>
                      {articulos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.name}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="descripcion"
                      type="text"
                      placeholder="descripcion"
                      value={inputField.descripcion}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="proveedor"
                      type="text"
                      placeholder="proveedor"
                      value={inputField.proveedor}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="marca"
                      type="text"
                      placeholder="marca"
                      value={inputField.marca}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="PO"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="PO"
                      value={inputField.PO}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="CBMS"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="CBMS"
                      value={inputField.CBMS}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  {/* <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col> */}

                  {/* <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col> */}
                  <Col>
                    <Button
                      size="sm"
                      color="danger"
                      title={t("Quitar")}
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      color="success"
                      title={t("Agregar")}
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
              </div>
            </div>
            <div className="form-section">
              <div className="form-section-header"><i className="fas fa-comment-alt" /><h4 className="form-section-title">{t("Observaciones")}</h4></div>
              <div className="form-section-body">
            <Row>
            <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  {t("Observaciones")}
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">
                  TOTAL {totalCantidad} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(totalGeneral)}
                </h4>
              </Col>
            </Row>
              </div>
            </div>
            {/* Termina Tabla Articulos */}

            <div className="submit-bar">
              {validaBoton ? (
                <Button type="submit" color="success">
                  <i className="fas fa-save" /> {t("Guardar")}
                </Button>
              ) : (
                <Button type="submit" color="success" disabled>
                  <i className="fas fa-save" /> {t("Guardar")}
                </Button>
              )}
              <Button
                href="/ListadoContenedores"
                color="secondary"
                id="botonListado"
              >
                <i className="fas fa-arrow-left" /> {t("Regresar")}
              </Button>
            </div>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>{t("Progreso")}</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                {t("Este proceso puede tardar varios segundos.")}
                <br />
                {t("Por favor no cierre ni refresque su navegador.")}
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ContenedoresCreate;
